<template>
  <component :is="productData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="productData === undefined">
      <h4 class="alert-heading">獲取商品數據時出錯</h4>
      <div class="alert-body">
        找不到相關商品記錄。請查看
        <b-link class="alert-link" :to="{ name: 'products-list' }">
          商品名單
        </b-link>
      </div>
    </b-alert>

    <product-edit-tab-information
      v-if="productData"
      :product-status-options="productStatusOptions"
      :product-unit-options="productUnitOptions"
      :product-categories-options="productCategoriesOptions"
      :product-data="productData"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import productStoreModule from "../productStoreModule";
import ProductEditTabInformation from "./productEditTabInformation.vue";

export default {
  components: {
    ProductEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const productData = ref({id: 0, total_price: null, unit_price: null});
    const product = {
      id: 0,
      total_price: null,
      unit_price: null,
    };

    const PRODUCT_APP_STORE_MODULE_NAME = "product";

    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME))
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, productStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PRODUCT_APP_STORE_MODULE_NAME))
        store.unregisterModule(PRODUCT_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "product-create") {
        productData.value = product;
      } else {
       
        store
          .dispatch("product/fetchProduct", { id: router.currentRoute.params.id })
          .then((response) => {
            productData.value = response.data.product;
            productData.value.quantity = parseFloat(Number(productData.value.quantity).toString());
            console.log(productData.value)
          })
          .catch((error) => {
            console.log("error when fetching product", error);
            if (error.response.status === 404) {
              productData.value = undefined;
            }
          });
      }
    };

    const productStatusOptions = ref([]);
    const productUnitOptions = ref([]);
    const productCategoriesOptions = ref([]);


    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          product_statuses: true,
          product_units:true,
          product_categories:true
        })
        .then((response) => {
          productStatusOptions.value = response.data.product_statuses;
          productUnitOptions.value = response.data.product_units;
          productCategoriesOptions.value = response.data.product_categories;
        });
    };

    onMounted(() => {
      refetchData();
      refetchOption();
    });

    return {
      productData,
      productStatusOptions,
      productUnitOptions,
      productCategoriesOptions,
      refetchOption,
    };
  },
};
</script>
